import {
  Component,
  OnInit,
  Input,
  ViewChild,
  ChangeDetectorRef,
  SimpleChanges,
  EventEmitter,
  Output,
} from "@angular/core";
import { CdkVirtualScrollViewport } from "@angular/cdk/scrolling";
import { FormArray, FormControl } from "@angular/forms";
import { refundsReport } from "../data-table/data-table-config/report/refunds-report.config";
import { DataTable } from "../data-table/data-table.interface";
import { SCHEMAS } from "../data-table/data-table.config";
import { MatDialog } from "@angular/material/dialog";
import { MatPaginator } from "@angular/material/paginator";
import { MatTableDataSource } from "@angular/material/table";

@Component({
  standalone: false,
  selector: "app-data-table-with-virtual-scroll",
  templateUrl: "./data-table-with-virtual-scroll.component.html",
  styleUrls: ["./data-table-with-virtual-scroll.component.scss"],
})
export class DataTableWithVirtualScrollComponent implements OnInit {
  @Input() cart: any[];
  @Input() type: string;

  @Output() iconActionHeader = new EventEmitter<any>();
  @ViewChild(CdkVirtualScrollViewport, { read: false })
  viewPort: CdkVirtualScrollViewport;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  dataSource: MatTableDataSource<any>;
  actionHeader = [];
  displayedColumns: any;
  showOtherHeader = false;
  itemValue = [];
  loading = [];
  checkboxRows = new FormArray([]);
  selectedAll = false;
  partiallySelected = false;
  selectedRows = [];
  listQuantity = [];
  columnList: any;

  dataTable: DataTable = refundsReport;

  constructor(
    public dialog: MatDialog,
    private cdr: ChangeDetectorRef
  ) 
  {}

  ngOnChanges(changes: SimpleChanges): void {
    this.showOtherHeader = false;
    if (changes && changes['cart']) {
      this.dataSource = new MatTableDataSource([...this.cart]);
      this.assignCheckbox(this.cart);
    }
    this.assignTableColumns();
  }

  ngOnInit() {
    this.assignTableColumns();
    if (this.dataTable.checkbox) {
      this.getIconHeader();
    }
  }

  assignCheckbox(cart) {
    this.selectedRows = [];
    this.checkboxRows = new FormArray([]);
    this.initializeCheckbox();
    cart.forEach(() => {
      this.addCheckboxRow();
    });
  }

  addCheckboxRow() {
    this.checkboxRows.push(new FormControl(false));
  }

  initializeCheckbox() {
    this.selectedAll = false;
    this.partiallySelected = false;
  }

  changeSelectCheckbox() {
    this.initializeCheckbox();
    const checkeds = this.checkboxRows.value.filter((checkbox) => checkbox);
    if (checkeds && checkeds.length > 0) {
      if (checkeds.length === this.cart.length) {
        this.selectedAll = true;
      } else {
        this.partiallySelected = true;
      }
    }
  }

  validateSelectedRows(event, row) {
    if (event.checked) {
      const isExist = this.findRowByIndex(row);
      if (isExist < 0) {
        this.selectedRows.push(row);
      }
    } else {
      const isExist = this.findRowByIndex(row);
      if (isExist >= 0) {
        this.selectedRows.splice(isExist, 1);
      }
    }
  }

  findRowByIndex(row) {
    return this.selectedRows.findIndex(
      (element) => JSON.stringify(element) === JSON.stringify(row)
    );
  }

  selectionOfAllCheckbox(event) {
    this.selectedRows = [];
    this.initializeCheckbox();
    if (event.checked) {
      this.selectedRows = this.cart;
      this.selectedAll = true;
      this.checkboxRows.value.forEach((checkbox, i) => {
        this.checkboxRows.controls[i].setValue(true);
      });
    } else {
      this.selectedAll = false;
      this.checkboxRows.value.forEach((checkbox, i) => {
        this.checkboxRows.controls[i].setValue(false);
      });
    }
  }

  getIndexItem(index) {
    return index;
  }

  initPaginator() {
    this.dataSource.paginator = this.paginator;
    this.paginator._intl.firstPageLabel = "Primera página";
    this.paginator._intl.lastPageLabel = "Ultima página";
  }

  moveScroll() {}

  assignLoading(cart) {
    this.loading = [];
    cart.forEach(() => {
      this.addLoading();
    });
  }

  /**
   * intert loading controls table
   */
  addLoading() {
    this.loading.push({
      isLoadingStocks: false,
      isLoadingDate: false,
      isLoadingDestination: false,
    });
  }

  trackById = (_index: number, item: any) => {
    return item.skuCode;
  };


  assignTableColumns() {
    this.dataTable = this.getSchemaByType(this.type);
    this.displayedColumns = this.dataTable.columns;
  }

  getIconHeader() {
    this.actionHeader = [];
    this.actionHeader.push({
      icon: "actions",
      action:
        this.getSchemaByType(this.type) &&
        this.getSchemaByType(this.type).iconsOfActions
          ? this.getSchemaByType(this.type).iconsOfActions.slice()
          : [],
    });
    this.actionHeader = Array.from(new Set(this.actionHeader));
  }

  getSchemaByType(type: string) {
    return SCHEMAS[type];
  }

  onClickIconHeader(icon, index) {
    const send = {
      data: [...this.selectedRows],
      action: icon,
      index: this.getIndexItem(index),
    };
    this.iconActionHeader.emit(send);
  }

  onChangeValue(value, indice) {
    this.itemValue[indice] = value;
  }
  
  hasHiddenIconHeader(typeIcon: any): boolean {
    const selection: any = this.selectedRows;
    return !typeIcon.hasVisibleCondition(selection);
  }

get inverseOfTranslation(): string {
  const offset = this.viewPort?.getOffsetToRenderedContentStart?.() ?? 0;
  return `-${offset}px`;
}
}
